(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'MyTripsAccountClientNoLoyaltyPrograms',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('.no-loyalty-programs').on('click', function enableSaveButton() {
			$('.no-loyalty-program-button').toggleClass('disabled');
		});
	};

}(jQuery, window.Adzuki || {}));
